import { UniversalSurfaceRenderer } from '../../../platform/UniversalSurfaceRenderer';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { ActiveObject, resolve } from '../../Container';
import { Camera } from '../../canvas/Camera';
import { OverlayHandle } from '../../canvas/overlay/Overlay';
import { OverlayManager } from '../../canvas/overlay/OverlayManager';
import { EmojiParticle } from './particles/EmojiParticle';
import { FrameParticle } from './particles/FrameParticle';
import { Particle } from './particles/Particle';
import { StarParticle } from './particles/StarParticle';

export class ParticleManager extends ActiveObject {

    @resolve(Camera) private camera: Camera;
    @resolve(OverlayManager) private overlays: OverlayManager;

    private handle: OverlayHandle;
    private items = [] as Particle[];
    private lastTick = 0;

    public start() {
        this.handle = this.overlays.createOverlay('particles', this.onOverlayPaint);
        this.overlays.add(this.handle);
        this.burden(
            this.handle,
            () => this.overlays.remove(this.handle),
        );
        this.scheduler.timeout('start', 500, () => {
            this.tick();
        });
    }

    public fireStars(rect: Rect) {
        const path = rect.toPolyline().toPath();
        this.items.push(new FrameParticle(rect.center(), rect.width, rect.height));

        for (let i = 0; i < 30; i++) {
            const t = i / 30;
            const p = path.pointAt(t);
            const v = Point.vector(rect.center(), p).normalize();
            this.items.push(new StarParticle(p, v, 10));
        }

        requestAnimationFrame(this.tick);
    }

    public fireEmojiCloud(at: Point, size: number) {
        this.items.push(new EmojiParticle(at, Point.up));
    }

    private tick = (time: number = 0) => {

        // if (this.items.length === 0) {
        //     this.splurge(new Rect(-50, -75, 100, 150));
        // }

        if (!!time && !!this.lastTick && this.items.length) {
            const dt = (time - this.lastTick) / 1000;
            this.items = this.items.filter(x => x.update(dt));
            this.handle.invalidate(false, true);
        }

        this.lastTick = time;
        requestAnimationFrame(this.tick);
    };

    private onOverlayPaint = (gfx: UniversalSurfaceRenderer) => {

        const mvm = this.camera.modelViewMatrix;

        for (const p of this.items) {
            p.paint(gfx, mvm);
        };

    };
}
